export enum SortType {
  ASC = 'asc',
  DESC = 'desc',
}
